import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function PaginaLegale({ tipo, onChiudi }) {
  const [testo, setTesto] = useState('')
  const [caricamento, setCaricamento] = useState(true)
  const oggi = new Date().toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })
  const titoloPagina = tipo === 'privacy' ? 'Privacy Policy' : 'Termini di Servizio'
  const chiave = tipo === 'privacy' ? 'privacy' : 'tos'

  useEffect(() => {
    supabase
      .from('impostazioni_app')
      .select('valore')
      .eq('chiave', chiave)
      .maybeSingle()
      .then(({ data }) => {
        setTesto(data?.valore || '')
        setCaricamento(false)
      })
  }, [chiave])

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <div className="topbar">
        <button className="back-btn" onClick={onChiudi}>&larr;</button>
        <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14 }}>{titoloPagina}</div>
        <div style={{ width: 32 }} />
      </div>

      <div className="scroll-area">
        <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 16 }}>
          Ultimo aggiornamento: {oggi}
        </div>

        {caricamento ? (
          <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>Caricamento...</div>
        ) : (
          <>
            {(() => {
              // Raggruppa le righe in sezioni: ogni titolo con il suo testo
              const righe = testo.split('\n')
              const sezioni = []
              let corrente = null

              for (const riga of righe) {
                if (!riga.trim()) continue
                const isTitolo = /^\d+\./.test(riga.trim()) ||
                  (riga === riga.toUpperCase() && riga.trim().length > 4 && !riga.includes('.'))
                if (isTitolo) {
                  if (corrente) sezioni.push(corrente)
                  corrente = { titolo: riga, testo: [] }
                } else {
                  if (corrente) corrente.testo.push(riga)
                  else sezioni.push({ titolo: null, testo: [riga] })
                }
              }
              if (corrente) sezioni.push(corrente)

              return sezioni.map((s, i) => (
                <div key={i} className="card" style={{ marginBottom: 10 }}>
                  <div className="card-body">
                    {s.titolo && (
                      <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 13, marginBottom: s.testo.length ? 8 : 0, color: 'var(--text)' }}>
                        {s.titolo}
                      </div>
                    )}
                    {s.testo.map((r, j) => (
                      <div key={j} style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7, marginTop: j > 0 ? 4 : 0 }}>
                        {r}
                      </div>
                    ))}
                  </div>
                </div>
              ))
            })()}
            <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--muted)', paddingTop: 16 }}>
              FitProgress · fitprogress.it · fitprogressapp@gmail.com
            </div>
          </>
        )}
      </div>
    </div>
  )
}
